
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prep-fq/pdf-viewer",
      function () {
        return require("private-next-pages/prep-fq/pdf-viewer.tsx");
      }
    ]);
  